module.exports = "/_next/static/images/15-9847b907c406a6affa3457f6ea9c27ef.png";